import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trevor/ui-components';
import {
  fetchAbsolutePath,
  fetchJson,
  postJson,
} from '@/util/helpers/ajax-helpers';
import { MODAL_IMPORT_VIEWS } from '../../util/enums/EnumModals';
import DatasourceRef from '../../util/DatasourceRef';
import { deserialiseViews } from '../../reducers/views';
import { changeTab } from '../../actions';
import AjaxSpinner from '../AjaxSpinner';
import Checkbox from '../configure/Checkbox';
import { VIEWS } from '../../util/enums/views.constants';

const DEFAULT_OPTION = '---choose---';

class ModalImportViews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      done: false,
      error: null, // error msg
      datasources: [], // list of DatasourceRefs
      selectedDatasource: DEFAULT_OPTION, // id of datasource
      views: [], // list of ViewRef objs
      selectedViews: [], // list of view ids
      searchValue: '',
    };
    this.search = this.search.bind(this);
  }

  static modalType() {
    return MODAL_IMPORT_VIEWS;
  }

  static reducer() {
    return null;
  }

  static title() {
    return <span>Import queries from another datasource</span>;
  }

  static subTitle() {
    return '';
  }

  static includeSaveButton() {
    return false;
  }

  error(e, msg) {
    window.console.error(e);
    this.setState({
      error: msg,
      loading: false,
    });
  }

  componentDidMount() {
    fetchJson('/views/other-datasources')
      .then((json) => {
        this.setState({
          datasources: json.map((d) => new DatasourceRef(d._id, d._name)),
          loading: false,
        });
      })
      .catch((e) => {
        this.error(e, 'Problem loading list of datasources');
      });
  }

  onSelectDatasource(datasourceId) {
    this.setState({
      loading: true,
      selectedDatasource: datasourceId,
      views: [], // reset
      selectedViews: [], // reset
    });
    fetchAbsolutePath(`/datasources/${datasourceId}/views/find`, true)
      .then((json) => {
        this.setState({
          views: deserialiseViews(json._views),
        });
        setTimeout(() => {
          this.setState({
            loading: false,
          });
          if (this._input) {
            this._input.focus();
          }
        }, 500);
      })
      .catch((e) =>
        this.error(e, 'Problem loading list of queries for datasource'),
      );
  }

  onSelectView(viewId, turnOn) {
    if (turnOn) {
      this.setState({
        selectedViews: [...this.state.selectedViews, viewId],
      });
    } else {
      this.setState({
        selectedViews: this.state.selectedViews.filter((id) => id !== viewId),
      });
    }
  }

  importViews() {
    this.setState({
      loading: true,
    });
    postJson('/views/copy', {
      _datasourceId: this.state.selectedDatasource,
      _viewIds: this.state.selectedViews,
    })
      .then(() => {
        this.props.onDone(); // refreshes loaded views (so user can see them)
        this.setState({
          done: true,
        });
      })
      .catch((e) => this.error(e, 'Problem copying saved query.'));
  }

  search(value) {
    this.setState({
      searchValue: value,
    });
  }

  render() {
    if (this.state.done) {
      return (
        <div className="alert alert-success" role="alert">
          Successfully imported {this.state.selectedViews.length} saved queries
          into your datasource.
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div className="alert alert-danger" role="alert">
          {this.state.error}
        </div>
      );
    }
    if (this.state.loading) {
      return <AjaxSpinner small />;
    }

    const datasourceChoices = this.state.datasources.map((d) => {
      return (
        <option key={d.id()} value={d.id()}>
          {d.name()}
        </option>
      );
    });
    const insights = this.state.views
      .filter((array) => {
        const v = array[0];
        const author = array[1];
        const saveDate = v.saved().slice(0, 10);
        const string = (v.name() + author + saveDate).toLowerCase();
        const searchQuery = this.state.searchValue;
        if (searchQuery.length > 2) {
          if (string.includes(searchQuery.toLowerCase().trim())) {
            return true;
          }
          return false;
        }
        return true;
      })
      .map((pair) => {
        const v = pair[0];
        const author = pair[1];
        const saveDate = v.saved().slice(0, 10);
        const on = this.state.selectedViews.indexOf(v.id()) > -1;
        return (
          <div
            key={v.id()}
            className="insightRow"
            style={{ cursor: 'default' }}
          >
            <div>
              <Checkbox
                selected={on}
                handleChange={() => this.onSelectView(v.id(), !on)}
              />
            </div>
            <div className="checkboxAndName">
              <span className="margin-left-10 margin-bottom-5">
                <b>{v.name()}</b>
              </span>
              <div className="small faint">
                <span className="margin-left-10">
                  Saved on {saveDate} by {author}
                </span>
              </div>
            </div>
          </div>
        );
      });
    return (
      <div style={{ fontSize: '14px' }} className="margin-10">
        <p>
          <b>Datasource</b>
        </p>
        <select
          style={{ maxWidth: '300px', height: '42px' }}
          value={this.state.selectedDatasource}
          className="form-control"
          onChange={(e) => this.onSelectDatasource(e.currentTarget.value)}
        >
          {this.state.selectedDatasource === DEFAULT_OPTION ? (
            <option value={DEFAULT_OPTION}>{DEFAULT_OPTION}</option>
          ) : null}
          {datasourceChoices}
        </select>

        <div className="margin-top-20">
          {this.state.selectedDatasource === DEFAULT_OPTION ? (
            ''
          ) : this.state.views.length === 0 ? (
            <h5>No saved queries found.</h5>
          ) : (
            ''
          )}
        </div>
        {this.state.views.length > 0 ? (
          <input
            ref={(input) => (this._input = input)}
            className="importViewsSearch"
            value={this.state.searchValue}
            placeholder="Find queries to import"
            onChange={(e) => this.search(e.target.value)}
          />
        ) : null}
        <div>{insights}</div>
        {insights.length === 0 ? null : (
          <div className="margin-top-20">
            <Button
              size="large"
              onClick={() => this.importViews()}
              disabled={this.state.selectedViews.length === 0}
            >
              Import {this.state.selectedViews.length} queries
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDone: () => {
      dispatch(changeTab(VIEWS));
    },
  };
};

export default connect(null, mapDispatchToProps)(ModalImportViews);
